import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function UKEUStudents() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    UK/EU Students
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Start Your Journey at DTK College
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Getting Started Section */}
        <section style={{ padding: '80px 0 40px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-4">
                  <h3 style={{ color: '#7B3F9E', fontSize: '2.2rem', fontWeight: '700', marginBottom: '15px' }}>
                    Getting Started at DTK College
                  </h3>
                  <div style={{ width: '80px', height: '4px', backgroundColor: '#7B3F9E', margin: '0 auto', borderRadius: '2px' }}></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Admission Procedure Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <h4 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                        Admission Procedure for UK/EU Students
                      </h4>
                      <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                        Admission Procedure for UK/EU Students: students who are UK/ EU Nationals or Non-EU applicants and are already in the UK should follow this procedure.
                      </p>
                    </div>
                    <div className="col-md-4 text-center">
                      <div style={{
                        width: '200px',
                        height: '150px',
                        backgroundColor: '#FAF8FC',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto'
                      }}>
                        <span style={{ fontSize: '4rem' }}>📚</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Selection Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="d-flex align-items-center mb-3">
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#7B3F9E',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}>
                      <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>1</span>
                    </div>
                    <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '0' }}>
                      Course Selection
                    </h4>
                  </div>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '70px' }}>
                    Carefully choose the course which is right for you. If you require assistance please contact the Admissions Office. Keep in mind the prerequisites for courses and the career path you intend to take. Computing certifications are for key skills, programming languages for entry into promotion. Academic courses in business and computing are for paths to further study leading to bachelors or masters.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Complete Enrolment Form Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="d-flex align-items-center mb-3">
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#7B3F9E',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}>
                      <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>2</span>
                    </div>
                    <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '0' }}>
                      Complete an Enrolment Form
                    </h4>
                  </div>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '70px' }}>
                    After choosing your course you can you can complete our Enrolment Form which can be downloaded from here and emailed, faxed, posted or by hand. Please take care to write the correct start dates, course name and code. If you need assistance, please do not hesitate to contact us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Supporting Documentation Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="d-flex align-items-center mb-3">
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#7B3F9E',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}>
                      <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>3</span>
                    </div>
                    <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '0' }}>
                      Provide Supporting Documentation
                    </h4>
                  </div>
                  <div style={{ paddingLeft: '70px' }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                      DTK College requires the following additional documentation to process your application for admission:
                    </p>
                    <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0' }}>
                      <li style={{ marginBottom: '10px' }}>a completed admission form</li>
                      <li style={{ marginBottom: '10px' }}>two passport sized photographs</li>
                      <li style={{ marginBottom: '10px' }}>Copies of educational qualifications – diploma, degree, College or school results. (Do not send these if there are no course prerequisites)</li>
                      <li style={{ marginBottom: '10px' }}>If you are applying as a mature student with no previous academic qualifications please provide your CV/ Resume and employers references.</li>
                      <li>The course registration fee</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Acceptance Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="d-flex align-items-center mb-3">
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#7B3F9E',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}>
                      <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>4</span>
                    </div>
                    <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '0' }}>
                      Course Acceptance
                    </h4>
                  </div>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '70px' }}>
                    Once your application has been considered you will be informed of the outcome by post/email and, if successful an enrolment letter sent to you along with a student timetable and course details.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final Payment Section */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="d-flex align-items-center mb-3">
                    <div style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#7B3F9E',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      flexShrink: 0
                    }}>
                      <span style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '700' }}>5</span>
                    </div>
                    <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '0' }}>
                      Final Payment
                    </h4>
                  </div>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '70px' }}>
                    Payment of the balance of your course fees will be due within 1 month of starting the course.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default UKEUStudents;